module.exports = new __parcel__URL__("flag-enabled.1378f3de.svg").toString();